import axios from "axios";
import { API_BASE } from "../config/api";

export async function signInWithGoogleCredential(credential) {
  if (!credential) throw new Error("Google did not return a sign-in credential.");
  const { data } = await axios.post(
    `${API_BASE}/client-auth/google?response=json`,
    new URLSearchParams({ credential }).toString(),
    { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
  );
  if (!data?.token || !data?.client) {
    throw new Error("The server did not return a valid sign-in session.");
  }
  return data;
}
